// Passenger CRUD Reducer
// Handles passenger creation, updates, and deletion

import type { ClaimState, ClaimAction } from './types';
import { toPassengers, createNewPassenger } from './types';

export function passengerReducer(state: ClaimState, action: ClaimAction): ClaimState | null {
  switch (action.type) {
    case 'SET_EXTRACTED_DATA':
      return {
        ...state,
        passengers: toPassengers(action.data.passengers),
        isDirty: true,
      };

    case 'UPDATE_PASSENGERS':
      return {
        ...state,
        passengers: action.passengers,
        isDirty: true,
      };

    case 'ADD_PASSENGER':
      return {
        ...state,
        passengers: [...state.passengers, createNewPassenger()],
        isDirty: true,
      };

    case 'UPDATE_PASSENGER':
      return {
        ...state,
        passengers: state.passengers.map((p) =>
          p._id === action.id ? { ...p, [action.field]: action.value } : p
        ),
        isDirty: true,
      };

    case 'DELETE_PASSENGER':
      return {
        ...state,
        passengers: state.passengers.filter((p) => p._id !== action.id),
        isDirty: true,
      };

    default:
      return null;
  }
}
